module.exports = __webpack_public_path__ + "img/chat.aee45e09.png";